module.exports = __webpack_public_path__ + "img/Boss-4.198b57ca.gif";